/**
 * Parse "10:30 AM" / "2:00 PM" to minutes-from-midnight (match mobile sort).
 */
export function parseBookingTimeToMinutes(bookingTime) {
  if (!bookingTime || typeof bookingTime !== 'string') return 0;
  const parts = bookingTime.trim().split(/\s+/);
  const timePart = parts[0] || '';
  const period = (parts[1] || '').toUpperCase();
  const [hStr, mStr] = timePart.split(':');
  let h = parseInt(hStr, 10) || 0;
  let m = parseInt(mStr, 10) || 0;
  let total = h * 60 + m;
  if (period === 'PM' && h !== 12) total += 12 * 60;
  if (period === 'AM' && h === 12) total -= 12 * 60;
  return total;
}
